<template>
  <div>
    <h1>Audio - Quiz</h1>

    <div
      id="carouselExampleIndicators"
      class="carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <ol class="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          class="active"
        ></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="7"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="8"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="9"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="10"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="11"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="12"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="13"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="14"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="15"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="16"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="17"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="18"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="19"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="20"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="21"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="22"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="23"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="24"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="25"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="26"></li>

      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <!-- <img class="d-block w-100" src="@/assets/spec-analyse-abl.jpg" alt="First slide"> -->
          <h2>
            Übungsteil zum Audio-Kapitel und Signalverarbeitung
          </h2>
          <p>
            Hier werden euch diverse Übungsaufgaben erwarten, probiert es
            einfach mit einem Klick auf den rechten Pfeil aus!
          </p>
        </div>
         <div class="carousel-item">
          <img src="@/assets/Audio_Quiz/Klang1.jpg" style="width: 30%;  position: absolute; top: 150px; right: 200px">
          <img src="@/assets/Audio_Quiz/Geräusch1.jpg" style="width: 30%;  position: absolute; top: 340px; right: 200px">
          <img src="@/assets/Audio_Quiz/Klang2.jpg" style="width: 30%;  position: absolute; top: 530px; right: 200px">
          <Audio_MC />
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioMC_done">
            <h2>
              Ordne den Signalen im Zeitbereich die richtigen Betragsspektren zu.
            </h2>
            <img src="@/assets/Audio_Quiz/deterministic_signals_slots.jpg" style="width: 70%;">
            <img src="@/assets/Audio_Quiz/deterministic_signals_choices.jpg" style="width: 70%; padding-top: 150px">
            <Audio_DnD2 id="lists2" ref="testcomponent2"/>
            <button id="button3" v-on:click="evaluate3">Prüfen</button>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_MC5 v-if="this.$store.state.audioDnD2_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_MC3 v-if="this.$store.state.audioMC5_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_Form3 v-if="this.$store.state.audioMC3_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
         <div class="carousel-item">
          <Audio_MC4 v-if="this.$store.state.audioForm3_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioMC4_done">
            <img src="@/assets/Audio_Quiz/PCM.png" style="width: 60%;">
            <Audio_MC2 />
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
          
        </div>
        <div class="carousel-item">
          <Audio_MC9 v-if="this.$store.state.audioMC2_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_Form4 v-if="this.$store.state.audioMC9_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_Form5 v-if="this.$store.state.audioForm4_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm5_done">
            <h2>
              Beschrifte die Bestandteile eines Lautsprechers.
            </h2>
            <img src="@/assets/dynLS.png" style="width: 60%;">
            <Audio_DnD3 id="lists3" ref="testcomponent3"/>
            <button id="button4" v-on:click="evaluate4">Prüfen</button>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_Form v-if="this.$store.state.audioDnD3_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_MC6 v-if="this.$store.state.audioForm_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_Form2 v-if="this.$store.state.audioMC6_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm2_done">
            <Audio_Form6/>
            <button id = "showlsg2" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong2">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle2" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle2">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Schalldruck.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm6_done">
            <Audio_MC7 />
            <button id = "showlsg3" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong3">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle3" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle3">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Schalldruck2.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioMC7_done">
            <img src="@/assets/Audio_Quiz/Bildschirmfoto_2022-02-10_um_18.41.10.png" style="width: 70%;">
            <Audio_DnD id="lists" ref="testcomponent"/>
            <button id="button1" v-on:click="evaluate2">Prüfen</button>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioDnD_done">
            <Audio_Form7 />
            <button id = "showlsg4" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong4">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong4" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle4" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle4">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Frequenz.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm7_done">
            <Audio_Form8 />
          <button id = "showlsg5" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong5">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle5" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg2" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle5">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Schalldruck3.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm8_done">
            <h2>Typische Klausuraufgaben</h2>
            <br>
            <h4>
            Das Signal einer Standard Stereo-Audio-CD hat eine Abtastfrequenz von 44.100 Hz.
            Die Datenrate einer solchen CD liegt bei 1,4112Mbit/s.
            Wie kommt diese Datenrate zustande?
            </h4>
            <p>Diese Aufgabe hat keine Überprüfungsfunktion, da man das Herleiten der Zahl auf viele Arten darstellen kann. In diesem Textfeld kannst du es selbst probieren und unten findest du eine Beispiellösung.</p>
            <br>
            <textarea id="text" name="text" cols="100" rows="10"></textarea>
            <br><br>
            <button id = "showlsg" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    Formel: <font style="color: green">Datenrate</font> = <font style="color: red">Abtastfrequenz</font> * 
                    <font style="color: orange">Bits für quantisierten Wert</font> * <font style="color: purple">Anzahl der Kanäle</font> 
                    <br><br>
                    <font style="color: orange">Audio-CD Quantisierung</font> => 16bit
                    <br>                   
                    <font style="color: purple">Stereo</font> => 2 Kanäle
                    <br>
                    1,4112 Mbit/s = 1411,2 kbit/s
                    <br>
                    <font style="color: red">44.100Hz = 44100 1/s</font> 
                    <br><br>
                    In Formel einsetzen:
                    <br>
                    <font style="color: green">1411,2kbit/s</font> = <font style="color: red">44100 1/s</font> * 
                    <font style="color: orange">16bit</font>  * <font style="color: purple">2</font> = <font style="color: green">1,4112 Mbit/s</font> 

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_KL v-if="this.$store.state.audioForm8_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <Audio_KL2 v-if="this.$store.state.audioKL_done"/>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioKL2_done">
            <Audio_Form10 />
            <button id = "showlsg8" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong8">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong8" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle8" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg3" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle8">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Pegel.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm10_done">
            <Audio_Form11 />
            <button id = "showlsg9" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong9">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong9" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle9" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg3" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle9">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Pegel2.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>              
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm11_done">
            <Audio_Form9 />
            <button id = "showlsg6" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong6">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong6" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle6" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg3" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle6">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Speicher.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
        <div class="carousel-item">
          <div v-if="this.$store.state.audioForm9_done">
            <Audio_MC8 />
          <button id = "showlsg7" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong7">Beispiellösung</button>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong7" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle7" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div id = "widelsg3" class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle7">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="text-align: left">
                    <img src="@/assets/Audio_Quiz/Lsg_Frequenz2.jpg">

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2>
              Dieser Slider ist noch nicht freigeschaltet. Löse dafür erst die vorherigen Aufgaben!
            </h2>
          </div>
        </div>
         
        
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span id ="test" class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
import Audio_MC from "../MC_components/Audio_MC.vue";
import Audio_Form from "../Form_Components/Audio_Form.vue";
import Audio_Form2 from "../Form_Components/Audio_Form2.vue";
import Audio_Form3 from "../Form_Components/Audio_Form3.vue";
import Audio_Form4 from "../Form_Components/Audio_Form4.vue";
import Audio_Form5 from "../Form_Components/Audio_Form5.vue";
import Audio_Form6 from "../Form_Components/Audio_Form6.vue";
import Audio_Form7 from "../Form_Components/Audio_Form7.vue";
import Audio_Form8 from "../Form_Components/Audio_Form8.vue";
import Audio_Form9 from "../Form_Components/Audio_Form9.vue";
import Audio_Form10 from "../Form_Components/Audio_Form10.vue";
import Audio_Form11 from "../Form_Components/Audio_Form11.vue";
import Audio_DnD from "../DnD_components/Audio_DnD.vue";
import Audio_DnD2 from "../DnD_components/Audio_DnD2.vue";
import Audio_DnD3 from "../DnD_components/Audio_DnD3.vue";
import Audio_MC2 from "../MC_components/Audio_MC2.vue";
import Audio_MC3 from "../MC_components/Audio_MC3.vue";
import Audio_MC4 from "../MC_components/Audio_MC4.vue";
import Audio_MC5 from "../MC_components/Audio_MC5.vue";
import Audio_MC6 from "../MC_components/Audio_MC6.vue";
import Audio_MC7 from "../MC_components/Audio_MC7.vue";
import Audio_MC8 from "../MC_components/Audio_MC8.vue";
import Audio_MC9 from "../MC_components/Audio_MC9.vue";
import Audio_KL from "../MC_components/Audio_KL.vue";
import Audio_KL2 from "../MC_components/Audio_KL2.vue";

export default {
  name: "DnD",
  components: {
    Audio_MC,
    Audio_Form,
    Audio_Form2,
    Audio_Form3,
    Audio_Form4,
    Audio_Form5,
    Audio_Form6,
    Audio_Form7,
    Audio_Form8,
    Audio_Form9,
    Audio_Form10,
    Audio_Form11,
    Audio_DnD,
    Audio_DnD2,
    Audio_DnD3,
    Audio_MC2,
    Audio_MC3,
    Audio_MC4,
    Audio_MC5,
    Audio_MC6,
    Audio_MC7,
    Audio_MC8,
    Audio_MC9,
    Audio_KL,
    Audio_KL2,
    

  },
  methods: {
    evaluate2: function (event) {
      if (event) {
        this.$refs.testcomponent.test();
      }
    },
    evaluate3: function (event) {
      if (event) {
        this.$refs.testcomponent2.test();
      }
    },
    evaluate4: function (event) {
      if (event) {
        this.$refs.testcomponent3.test();
      }
    },
  },
};
</script>

<style>
#widelsg, #widelsg2, #widelsg3 {
  width: 1000px;
}
#showlsg2, #showlsg3, #showlsg4, #showlsg5, #showlsg6, #showlsg7, #showlsg8, #showlsg9 {
  position: absolute;
  top: 650px;
  left: 640px;
}
.modal-content {
    width: 650px;
}
#hintergrund {
  /* position: absolute; */
  left: 300px;
}

#button1, #button3, #button4 {
  position: absolute;
  left: 650px;
  top: 550px;
  font-family: sans-serif;
  font-size: 20px;
  /* background-color: #297; */
  color: #fff;
  border: 0px;
  border-radius: 3px;
  padding: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  background-color: #528382
}
#button3 {
  top: 620px
}
#button4 {
  top: 650px
}
#DnD {
  height: 800px;
}

/* Styles für das Drag/Drop  */
.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  /* height: 500px; */
  overflow: hidden;
  margin: 0 auto;
  padding: 15px;
}
</style> 
